export default Object.freeze({
    HIT: 'HIT',
    TOP: 'TOP',
    DEVICE: 'DEVICE',
    INSURANCE_CLAIM: 'INSURANCE_CLAIM',
    HOME: 'HOME',
    CLONED: 'CLONED'
})